import * as React from 'react'
import * as Styled from './Billboard.styles'

const Billboard = ({
  image,
  mainContent = null,
  backgroundColor = null,
  backgroundImage = null,
  mobileBackgroundImage = null,
  textColor = null,
  mobileTextColor = null,
  variant = 'split',
  children = null,
  alignMainContent = 'Center',
  mobileAlignImageToBottom = false,
  mobileImage = null,
  topPadding = null,
  bottomPadding = null,
  width = null,
  ...props
}) => (
  <Styled.Section
    className={`leshen-billboard leshen-billboard-section-${variant} background-color-${
      backgroundColor || 'default'
    }`}
    data-testid="Billboard-Section"
    mobileAlignImageToBottom={mobileAlignImageToBottom}
    backgroundColor={backgroundColor}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    mobileTextColorEnd="lg"
    topPadding={topPadding}
    bottomPadding={bottomPadding}
    width={width}
    {...props}
  >
    {!mobileAlignImageToBottom && mobileImage && (
      <Styled.MobileImg
        mobileImage={mobileImage}
        hasBackgroundImage={Boolean(backgroundImage)}
        mobileAlignImageToBottom={mobileAlignImageToBottom}
      >
        {mobileImage}
      </Styled.MobileImg>
    )}
    <Styled.Img
      mobileImage={mobileImage}
      className={`image-${variant}`}
      variant={variant}
      hasBackgroundImage={Boolean(backgroundImage)}
    >
      {image}
    </Styled.Img>
    {backgroundImage && variant === 'split' && (
      <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
        {backgroundImage}
      </Styled.BackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    <Styled.Content
      className={`content content-${variant}`}
      data-testid="Billboard-Content"
      backgroundColor={backgroundColor}
      textColor={textColor}
      alignMainContent={alignMainContent}
      hasBackgroundImage={Boolean(backgroundImage)}
      mobileAlignImageToBottom={mobileAlignImageToBottom}
      variant={variant}
    >
      {backgroundImage && variant !== 'split' && (
        <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
          {backgroundImage}
        </Styled.BackgroundImage>
      )}
      {backgroundImage ? (
        <Styled.RelativeContent>
          {mainContent}
          {children}
        </Styled.RelativeContent>
      ) : (
        <>
          {mainContent}
          {children}
        </>
      )}
    </Styled.Content>
    {mobileAlignImageToBottom && mobileImage && (
      <Styled.MobileImg
        mobileImage={mobileImage}
        hasBackgroundImage={Boolean(backgroundImage)}
        mobileAlignImageToBottom={mobileAlignImageToBottom}
      >
        {mobileImage}
      </Styled.MobileImg>
    )}
  </Styled.Section>
)

export default Billboard
